import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addLeagueMapping } from "@/api/leaguesNew";
import { LeaguesNewQueryKeys } from "@/tanstackQuery/queries/leaguesNew";
import { AddLeagueMappingParams } from "@/types/ApiResponses/League";

export const useAddLeagueMapping = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: AddLeagueMappingParams) => addLeagueMapping(params),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [LeaguesNewQueryKeys.LeagueMappings, variables.leagueId],
      });
    },
  });
};
